import { StyleSheet } from "react-native";

import { useTranslation } from "@luna-restaurant/i18n";
import type {
  ThemedTableColumn,
  ThemedTableHeaderColumn,
} from "@luna-restaurant/ui";

import { CancelConfirmationModal } from "@/components/modals/CancelConfirmationModal";

export type CancelGuestOrderModalOrder = {
  id: string;
  dateRaw: string;
  date: string;
  totalMeals: string;
  comment?: string;
};

type CancelGuestOrderModalProps = {
  visible: boolean;
  order: CancelGuestOrderModalOrder | null;
  isSubmitting?: boolean;
  validationError?: string | null;
  onDismiss: () => void;
  onConfirm: (order: CancelGuestOrderModalOrder) => void;
};

export function CancelGuestOrderModal({
  visible,
  order,
  isSubmitting = false,
  validationError = null,
  onDismiss,
  onConfirm,
}: CancelGuestOrderModalProps) {
  const { t } = useTranslation();

  if (!order) {
    return null;
  }

  const headerColumns: ThemedTableHeaderColumn[] = [
    {
      width: 21,
      label: t("guestOrders.table.header.date"),
      style: styles.tableHeaderBold,
    },
    {
      width: 37.5,
      label: t("guestOrders.table.header.totalMeals"),
      style: styles.tableHeaderBold,
    },
    {
      width: 37.5,
      label: t("guestOrders.table.header.comment"),
      style: styles.tableHeaderBold,
    },
  ];

  const rowColumns: ThemedTableColumn[] = [
    {
      type: "text",
      label: order.date,
      style: styles.tableCellBold,
    },
    {
      type: "text",
      label: order.totalMeals,
    },
    {
      type: "text",
      label: order.comment ?? "--",
    },
  ];

  return (
    <CancelConfirmationModal
      visible={visible}
      translationPrefix="guestOrders.cancelModal"
      headerColumns={headerColumns}
      rowColumns={rowColumns}
      isSubmitting={isSubmitting}
      validationError={validationError}
      onDismiss={onDismiss}
      onConfirm={() => onConfirm(order)}
    />
  );
}

const styles = StyleSheet.create({
  tableHeaderBold: {
    fontWeight: "bold",
    fontFamily: "PoppinsBold",
  },
  tableCellBold: {
    fontWeight: "bold",
    fontFamily: "PoppinsBold",
  },
});
